<div class="privacy">
    <div class="corpopagina">
        <div class="viewPar BLOBAlignLeft">
            <p><strong class="userFormat1">Titolare del Trattamento dei Dati</strong></p>
        </div>
    </div>
</div>
